export const audienceFieldFilterFunction = (fieldName: string) =>
    ![
        'subscribedAudiences',
        'unsubscribedAudiences',
        'audiences',
        'period',
        'bouncedEditions',
        'marketingStatus',
        'includeExisting',
    ].includes(fieldName);
